import { memo } from 'react';

import { WorkspaceAgentDisclosure } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/disclosure/WorkspaceAgentDisclosure';
import { type WorkspaceAgentPhaseListItem } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/phases/types';
import { WorkspaceAgentPhaseList } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/phases/WorkspaceAgentPhaseList';

export type WorkspaceAgentWorkDisclosureProps = {
  'data-testid'?: string;
  defaultIsExpanded?: boolean;
  /** The one-line summary of the run, e.g. `Worked for 12s`. */
  label: string;
  phases: WorkspaceAgentPhaseListItem[];
};

/**
 * How the agent reached its answer, collapsed by default.
 *
 * The steps matter when the answer looks wrong and are noise the rest of the time, so the run is
 * summarised to a single line and the detail is opened on demand. Set in monospace to read as a
 * machine readout rather than as part of the reply.
 */
export const WorkspaceAgentWorkDisclosure = memo(
  ({ 'data-testid': testId, defaultIsExpanded, label, phases }: WorkspaceAgentWorkDisclosureProps) => (
    <WorkspaceAgentDisclosure
      data-testid={testId}
      defaultIsExpanded={defaultIsExpanded}
      trigger={<span className="block truncate font-mono font-semibold text-10 text-gray-10 leading-5">{label}</span>}
      triggerTooltip={label}
      variant="plain"
    >
      <WorkspaceAgentPhaseList phases={phases} variant="panel" />
    </WorkspaceAgentDisclosure>
  ),
);

WorkspaceAgentWorkDisclosure.displayName = 'WorkspaceAgentWorkDisclosure';
